export const ChartColors = [
  "#FF8A65",
  "#4FC3F7",
  "#FF5252",
  "#66BB6A",
  "#BA68C8",
  "#FFD54F",
  "#7986CB",
  "#4DB6AC",
  "#F06292",
  "#AED581",
];

export const FinancialColors = {
  income: "#4ade80",
  expense: "#f87171",
  profit: "#60a5fa",
  pending: "#fbbf24",

  category1: "#8b5cf6",
  category2: "#ec4899",
  category3: "#14b8a6",
  category4: "#f97316",
  category5: "#6366f1",

  positive: "#22c55e",
  negative: "#ef4444",
  neutral: "#94a3b8",

  incomeGradient: ["#4ade80", "#22c55e"],
  expenseGradient: ["#f87171", "#ef4444"],
  profitGradient: ["#60a5fa", "#3b82f6"],
};

export const CategoryColors = [
  "#8b5cf6",
  "#ec4899",
  "#14b8a6",
  "#f97316",
  "#6366f1",
  "#0ea5e9",
  "#84cc16",
  "#d946ef",
  "#f43f5e",
  "#10b981",
];
